import React from "react";
import PropTypes from "prop-types";
import styles from "./SecurityTeamItem.module.css";
import classNames from "classnames";

import PinCheckbox from "Security/Shared/PinCheckbox";

/**
 * Interactive component.
 * Used to display the security team and the event staff on the EventDetails page.
 * Items can be pinned to the top.
 */
export function SecurityTeamItem({ item, onPin }) {
  return (
    <div
      className={classNames(styles.container, {
        [styles.pinned]: item.pinned,
      })}
    >
      <div
        className={classNames(styles.checkbox, {
          [styles.hidden]: !item.pinned,
        })}
      >
        <div>
          <label htmlFor="pinned" hidden className={styles.none}>
            Pinned
          </label>
          <PinCheckbox pinned={item.pinned} onClick={onPin} />
        </div>
      </div>
      <p className={styles.name}>{item.name}</p>
      <p>{item.phoneNumber}</p>
      <p>{item.email}</p>
      <p>{item.CCW ? "Yes" : "No"}</p>
    </div>
  );
}

SecurityTeamItem.propTypes = {
  /**
   * Object with the member's info.
   */
  item: PropTypes.shape({
    pinned: PropTypes.bool,
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    CCW: PropTypes.bool,
  }),
  /**
   * Function called when the check box is clicked.
   */
  onPin: PropTypes.func,
};

SecurityTeamItem.defaultProps = {
  item: { pinned: false, name: "", phoneNumber: "", email: "", CCW: false },
};
